import { styled } from "@mui/material/styles";
import { Divider, GuideText } from "../../../../../StyledComponents";

export const GuideWorkspace = styled("section")({
  width: "100%",
  height: "100%",
  display: "grid",
  gridTemplateColumns: "24rem minmax(0, 1fr)",
  gap: "1.4rem",
  padding: "1.4rem 1.6rem 1.6rem 1.6rem",
  overflow: "hidden",
});

export const GuideSubjectPanel = styled("aside")({
  minHeight: 0,
  height: "100%",
  display: "grid",
  gridTemplateRows: "auto minmax(0, 1fr)",
  overflow: "hidden",
  background: "rgba(255,255,255,0.84)",
  border: "0.1rem solid rgba(120,139,158,0.24)",
  borderRadius: "0.8rem",
  boxShadow: "0 0.8rem 1.8rem rgba(71,85,105,0.08)",
});

export const GuideSubjectHeader = styled("header")({
  padding: "1.3rem 1.4rem 1.1rem 1.4rem",
  borderBottom: "0.1rem solid rgba(120,139,158,0.18)",
  background: "linear-gradient(180deg, rgba(248,250,252,0.94), rgba(241,245,249,0.72))",
});

export const GuideEyebrow = styled("div")({
  color: "#64748b",
  fontSize: "0.78rem",
  fontWeight: 900,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
});

export const GuideTitle = styled("div")({
  marginTop: "0.2rem",
  color: "#1f2937",
  fontSize: "1.45rem",
  fontWeight: 950,
  letterSpacing: 0,
});

export const GuideNavList = styled("nav")({
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  gap: "0.28rem",
  padding: "1rem",
  overflowY: "auto",
  overflowX: "hidden",

  "::-webkit-scrollbar": {
    width: "0.35rem",
  },

  "::-webkit-scrollbar-thumb": {
    borderRadius: "999px",
    background: "rgba(148,163,184,0.35)",
  },
});

export const GuideNavItem = styled("button")({
  width: "100%",
  minHeight: "3.25rem",
  display: "grid",
  gridTemplateColumns: "2.6rem minmax(0, 1fr)",
  alignItems: "center",
  gap: "0.35rem",
  border: "0.1rem solid transparent",
  borderRadius: "0.7rem",
  padding: "0 0.75rem",
  color: "#475569",
  background: "transparent",
  cursor: "pointer",
  textAlign: "left",
  transition: "background 160ms ease, border-color 160ms ease, color 160ms ease",

  "& svg": {
    width: "1.8rem",
    height: "1.8rem",
    color: "#2563eb",
  },

  "& span": {
    minWidth: 0,
    color: "currentColor",
    fontSize: "0.98rem",
    fontWeight: 850,
    lineHeight: 1.15,
  },

  "&:hover:not(:disabled)": {
    color: "#1f2937",
    background: "rgba(241,245,249,0.9)",
    borderColor: "rgba(120,139,158,0.18)",
  },

  "&.active": {
    color: "#1f2937",
    background: "rgba(37,99,235,0.1)",
    borderColor: "rgba(37,99,235,0.22)",
    boxShadow: "inset 0.22rem 0 0 #2563eb",
  },

  "&:disabled": {
    cursor: "default",
  },
});

export const GuideSubNavGroup = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "0.18rem",
  margin: "0 0 0.25rem 2.05rem",
  padding: "0.15rem 0 0.2rem 0.75rem",
  borderLeft: "0.1rem solid rgba(120,139,158,0.24)",
});

export const GuideSubNavItem = styled("button")({
  width: "100%",
  minHeight: "2.6rem",
  display: "grid",
  gridTemplateColumns: "2.1rem minmax(0, 1fr)",
  alignItems: "center",
  border: "0.1rem solid transparent",
  borderRadius: "0.65rem",
  padding: "0 0.65rem",
  color: "#64748b",
  background: "transparent",
  cursor: "pointer",
  textAlign: "left",
  transition: "background 160ms ease, border-color 160ms ease, color 160ms ease",

  "& span": {
    fontSize: "0.92rem",
    fontWeight: 800,
    lineHeight: 1.15,
  },

  "& .index": {
    fontSize: "0.78rem",
    fontWeight: 950,
  },

  "&:hover:not(:disabled)": {
    color: "#1f2937",
    background: "rgba(241,245,249,0.86)",
    borderColor: "rgba(120,139,158,0.16)",
  },

  "&.active": {
    color: "#2563eb",
    background: "rgba(37,99,235,0.08)",
    borderColor: "rgba(37,99,235,0.16)",
  },

  "&:disabled": {
    cursor: "default",
  },
});

export const GuideReader = styled("article")({
  minHeight: 0,
  maxWidth: '90rem',
  height: "100%",
  display: "grid",
  gridTemplateRows: "auto minmax(0, 1fr)",
  overflow: "hidden",
  background: "#ffffff",
  border: "0.1rem solid rgba(120,139,158,0.24)",
  borderRadius: "0.8rem",
  boxShadow: "0 1rem 2.2rem rgba(71,85,105,0.09)",
});

export const GuideReaderHeader = styled("header")({
  display: "grid",
  gridTemplateColumns: "1fr auto",
  gap: "1rem",
  alignItems: "center",
  padding: "1.3rem 1.5rem",
  borderBottom: "0.1rem solid rgba(120,139,158,0.18)",
  background: "linear-gradient(180deg, rgba(248,250,252,0.98), rgba(255,255,255,0.92))",
});

export const GuideBrandLockup = styled("div")({
  minWidth: 0,
  display: "flex",
  alignItems: "flex-end",
  gap: "0.8rem",

  "& img": {
    width: "18rem",
    height: "auto",
    opacity: 0.68,
  },
});

export const GuideReaderTitle = styled("div")({
  color: "#1f2937",
  fontSize: "1.65rem",
  fontWeight: 950,
  lineHeight: 1.1,
});

export const GuideReaderSubtitle = styled("div")({
  marginTop: "0.25rem",
  color: "#64748b",
  fontSize: "0.9rem",
  fontWeight: 850,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
});

export const GuidePager = styled("div")({
  display: "grid",
  gridTemplateColumns: "minmax(11rem, 1fr) minmax(11rem, 1fr)",
  gap: "0.6rem",
});

export const GuidePageButton = styled("button")({
  minHeight: "3.1rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.45rem",
  border: "0.1rem solid rgba(37,99,235,0.2)",
  borderRadius: "0.7rem",
  padding: "0 0.9rem",
  color: "#2563eb",
  background: "rgba(37,99,235,0.08)",
  fontSize: "0.92rem",
  fontWeight: 900,
  cursor: "pointer",
  transition: "background 160ms ease, border-color 160ms ease, color 160ms ease",

  "& svg": {
    width: "1.35rem",
    height: "1.35rem",
  },

  "&:hover:not(:disabled)": {
    color: "#1d4ed8",
    background: "rgba(37,99,235,0.13)",
    borderColor: "rgba(37,99,235,0.3)",
  },

  "&:disabled": {
    color: "#94a3b8",
    background: "rgba(148,163,184,0.08)",
    borderColor: "rgba(148,163,184,0.16)",
    cursor: "not-allowed",
  },
});

export const GuideArticleScroll = styled("section")({
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  padding: "2.1rem 2.4rem 3rem 2.4rem",

  "& > .overflowVerticalContainer": {
    width: "100%",
    maxWidth: "76rem",
    minHeight: "fit-content",
    margin: "0 auto",
    padding: 0,
    color: "#1f2937",
  },

  [`& ${GuideText}`]: {
    maxWidth: "72rem",
    color: "#334155",
    fontFamily:
      '-apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Inter", "Helvetica Neue", sans-serif',
    fontSize: "1.16rem",
    lineHeight: 1.58,
    letterSpacing: 0,
  },

  [`& ${GuideText}.newParagraph`]: {
    paddingTop: "1.15rem",
  },

  [`& ${GuideText}.header`]: {
    maxWidth: "66rem",
    color: "#111827",
    fontSize: "2rem",
    fontWeight: 900,
    lineHeight: 1.22,
  },

  [`& ${GuideText}.header.newParagraph`]: {
    paddingTop: "2.2rem",
  },

  [`& ${GuideText}.medium`]: {
    maxWidth: "68rem",
    color: "#334155",
    fontSize: "1.45rem",
    fontWeight: 750,
    lineHeight: 1.42,
  },

  [`& ${Divider}`]: {
    margin: "2.1rem 0",
    borderColor: "rgba(120,139,158,0.2)",
  },

  "& svg": {
    color: "#2563eb",
  },

  "::-webkit-scrollbar": {
    width: "0.45rem",
  },

  "::-webkit-scrollbar-thumb": {
    borderRadius: "999px",
    background: "rgba(148,163,184,0.45)",
  },

  "::-webkit-scrollbar-track": {
    background: "rgba(241,245,249,0.7)",
  },
});
